export default "__VITE_ASSET__CeIxCbH2__"